/**
 * @module app.ag
 */

import { FrameworkConfiguration } from 'aurelia-framework';
import { AppealsAndGrievancesManagementModule } from './module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(AppealsAndGrievancesManagementModule.registrationKey, AppealsAndGrievancesManagementModule);

    config.globalResources([
        // elements

        // elements/members

        // elements/providers

        // value-converters
    ]);
}
